import React from 'react';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';

/**
 * Componente TextField con contador de caracteres
 * @param {Object} props - Propiedades del componente
 * @param {number} props.maxLength - Longitud máxima de caracteres permitidos
 * @param {string} props.value - Valor actual del input
 * @param {function} props.onChange - Función callback cuando cambia el valor
 * @param {string} props.id - ID del campo
 * @param {string} props.label - Label del campo
 * @param {string} props.placeholder - Placeholder del campo
 * @param {string} props.className - Clases CSS adicionales
 * @param {Object} props.InputLabelProps - Props adicionales para InputLabel
 * @param {Object} props.InputProps - Props adicionales para Input (se mergeará con el contador)
 * @param {Object} props.inputProps - Props adicionales para el elemento input nativo (se mergeará con maxLength y style)
 * @param {*} rest - Cualquier otra prop que se pase se aplicará al TextField
 */
const TextFieldWithCounter = ({ 
	maxLength = 100,
	value = '',
	onChange,
	id,
	label,
	placeholder,
	className,
	InputLabelProps,
	InputProps = {},
	inputProps = {},
	...rest 
}) => {
	const handleChange = (e) => {
		const newValue = e.target.value;
		if (newValue.length <= maxLength) {
			onChange && onChange(e);
		}
	};

	const currentLength = value ? value.length : 0;

	return (
		<TextField
			id={id}
			type="text"
			InputLabelProps={value ? { shrink: true, ...InputLabelProps } : InputLabelProps}
			label={label}
			placeholder={placeholder}
			value={value}
			onChange={handleChange}
			className={className}
			InputProps={{
				...InputProps,
				endAdornment: (
					<InputAdornment position="end" style={{ marginLeft: 'auto' }}>
						<span style={{ fontSize: '0.75rem', color: '#666' }}>
							{currentLength}/{maxLength}
						</span>
					</InputAdornment>
				)
			}}
			inputProps={{ 
				maxLength: maxLength,
				style: { 
					overflow: 'auto',
					whiteSpace: 'nowrap',
					...inputProps.style
				},
				...inputProps
			}}
			{...rest}
		/>
	);
};

export default TextFieldWithCounter;

